import React, { useEffect, useState } from "react";
import { SelectInputWTitle } from "./SelectInputWTitle";

export const data = [
    {
        "Class_Type_Id": 1,
        "Class_Type_Name": "اکونومی",
        "Class_Type_EnName": "Economy"
    },
    {
        "Class_Type_Id": 2,
        "Class_Type_Name": "بیزینس",
        "Class_Type_EnName": "Business"
    }
]
export const ClassTypeV2Selector = ({
    style,
    name,
    title,
    error = "",
    first,
    value,
    onchange,
    placeHolder,
    selectableFirst,
    required,
    ltr,
    lan= false,
    disabled=false,
    search= false
}) => {
    
    let options = data.map((v) => {
        return {
            value: v.Class_Type_Id,
            name: (lan) ? v.Class_Type_EnName : v.Class_Type_Name
        }
    })
    return (
        <SelectInputWTitle
            style={style}
            name={name}
            title={title}
            error={error}
            options={options}
            first={first}
            value={value}
            onchange={onchange}
            selectableFirst={selectableFirst}
            placeHolder={placeHolder}
            required={required}
            ltr={ltr}
            lan={lan}
            disabled={disabled}
            search={search}
        />
    )

};